<template>
    <div class="asset-details-wrapper">
        <ValidationObserver v-slot="{ handleSubmit }" slim ref="info">
            <form @submit.prevent="handleSubmit(saveAsset())">

                <TabView>
                    <TabPanel header="General">
                        <ul class="asset-details">
                            <li>
                                <span>Name</span>
                                <span v-if="editAsset == false">
                                    <span v-if="asset.name">
                                        {{ asset.name }}
                                    </span>
                                    <span v-else><i>Unassigned</i></span>
                                </span>
                                <ValidationProvider rules="noComma" v-else name="Name" v-slot="{ errors }">
                                    <span class="field">
                                        <InputText type="text" class="p-inputtext p-d-block" placeholder="Enter Name" :class="{ 'p-invalid': errors.length > 0 }" v-model="info.name" />
                                        <small class="p-error p-d-block" v-if="errors[0]">
                                            {{ errors[0] }}
                                        </small>
                                    </span>
                                </ValidationProvider>
                            </li>
                            <li>
                                <span>Location Ref.</span>
                                <span v-if="editAsset == false">
                                    <span v-if="asset.location_reference">
                                        {{ asset.location_reference }}
                                    </span>
                                    <span v-else><i>Unassigned</i></span>
                                </span>
                                <ValidationProvider rules="noComma" v-else name="Location Ref." v-slot="{ errors }">
                                    <span class="field">
                                        <InputText type="text" class="p-inputtext p-d-block" placeholder="Enter Location Ref." :class="{ 'p-invalid': errors.length > 0 }" v-model="info.location_reference" />
                                        <small class="p-error p-d-block" v-if="errors[0]">
                                            {{ errors[0] }}
                                        </small>
                                    </span>
                                </ValidationProvider>
                            </li>
                            <li>
                                <span>Area</span>
                                <span v-if="editAsset == false">
                                    <span v-if="asset.area">
                                        {{ asset.area }}
                                    </span>
                                    <span v-else><i>Unassigned</i></span>
                                </span>
                                <ValidationProvider rules="noComma" v-else name="Area" v-slot="{ errors }">
                                    <span class="field">
                                        <InputText type="text" class="p-inputtext p-d-block" placeholder="Enter Area" :class="{ 'p-invalid': errors.length > 0 }" v-model="info.area" />
                                        <small class="p-error p-d-block" v-if="errors[0]">
                                            {{ errors[0] }}
                                        </small>
                                    </span>
                                </ValidationProvider>
                            </li>
                            <li>
                                <span>Sub-Area</span>
                                <span v-if="editAsset == false">
                                    <span v-if="asset.location">
                                        {{ asset.location }}
                                        <!-- asset.location = asset sub area -->
                                    </span>
                                    <span v-else><i>Unassigned</i></span>
                                </span>
                                <ValidationProvider rules="noComma" v-else name="Sub-Area" v-slot="{ errors }">
                                    <span class="field">
                                        <InputText type="text" class="p-inputtext p-d-block" placeholder="Enter Sub-Area" :class="{ 'p-invalid': errors.length > 0 }" v-model="info.location" />
                                        <small class="p-error p-d-block" v-if="errors[0]">
                                            {{ errors[0] }}
                                        </small>
                                    </span>
                                </ValidationProvider>
                            </li>
                            <li style="grid-column: span 2 / span 2;">
                                <span>Description</span>
                                <span v-if="editAsset == false">
                                    <span v-if="asset.description">
                                        {{ asset.description }}
                                    </span>
                                    <span v-else><i>Unassigned</i></span>
                                </span>
                                <ValidationProvider rules="noComma" v-else name="Description" v-slot="{ errors }">
                                    <span class="field">
                                        <InputText type="text" class="p-inputtext p-d-block" placeholder="Enter Description" :class="{ 'p-invalid': errors.length > 0 }" v-model="info.description" />
                                        <small class="p-error p-d-block" v-if="errors[0]">
                                            {{ errors[0] }}
                                        </small>
                                    </span>
                                </ValidationProvider>
                            </li>
                            <li style="grid-column: span 2 / span 2;">
                                <span>Additional Info</span>
                                <span v-if="editAsset == false">
                                    <span v-if="asset.additional_info">
                                        {{ asset.additional_info }}
                                    </span>
                                    <span v-else><i>Unassigned</i></span>
                                </span>
                                <ValidationProvider rules="noComma" v-else name="Additional Info" v-slot="{ errors }">
                                    <span class="field">
                                        <InputText type="text" class="p-inputtext p-d-block" placeholder="Enter Info" :class="{ 'p-invalid': errors.length > 0 }" v-model="info.additional_info" />
                                        <small class="p-error p-d-block" v-if="errors[0]">
                                            {{ errors[0] }}
                                        </small>
                                    </span>
                                </ValidationProvider>
                            </li>
                            <li style="grid-column: span 2 / span 2;">
                                <span>Exclude From Notifications</span>
                                <span v-if="editAsset == false">
                                    <InputSwitch disabled v-model="asset.excludeNotifications" />
                                </span>
                                <span v-else>
                                    <InputSwitch v-model="asset.excludeNotifications" />
                                </span>
                            </li>
                        </ul>
                    </TabPanel>
                    <TabPanel header="Contacts">
                        <div class="asset-details asset-details--cols">
                            <ul class="asset-details asset-details--contacts">
                                <li class="contact-header">PRIMARY CONTACT</li>
                                <li>
                                    <span>Name</span>
                                    <span v-if="editAsset == false">
                                        <span v-if="asset.primary_contact_name">
                                            {{ asset.primary_contact_name }}
                                        </span>
                                        <span v-else><i>Unassigned</i></span>
                                    </span>
                                    <ValidationProvider rules="noComma" v-else name="Primary Contact Name" v-slot="{ errors }">
                                        <span class="field">
                                            <InputText type="text" class="p-inputtext p-d-block" placeholder="Enter Name" :class="{ 'p-invalid': errors.length > 0 }" v-model="info.primary_contact_name" />
                                            <small class="p-error p-d-block" v-if="errors[0]">
                                                {{ errors[0] }}
                                            </small>
                                        </span>
                                    </ValidationProvider>
                                </li>
                                <li>
                                    <span>Telephone Number (UK)</span>
                                    <span v-if="editAsset == false">
                                        <span v-if="asset.primary_contact_phone">
                                            {{ asset.primary_contact_phone }}
                                        </span>
                                        <span v-else><i>Unassigned</i></span>
                                    </span>
                                    <span class="field" v-else>
                                        <InputText type="number" class="p-inputtext p-d-block" placeholder="Enter Telephone Number" v-model="info.primary_contact_phone" />
                                    </span>
                                </li>
                                <li>
                                    <span>Email Address</span>
                                    <span v-if="editAsset == false">
                                        <span v-if="asset.primary_contact_email">
                                            {{ asset.primary_contact_email }}
                                        </span>
                                        <span v-else><i>Unassigned</i></span>
                                    </span>
                                    <ValidationProvider rules="email" v-else name="Email Address" v-slot="{ errors }">
                                        <span class="field">
                                            <InputText class="p-inputtext p-d-block" placeholder="Enter Email Address" :class="{ 'p-invalid': errors.length > 0 }" v-model="info.primary_contact_email" />
                                            <small id="" class="p-error p-d-block" v-if="errors[0]">
                                                {{ errors[0] }}
                                            </small>
                                        </span>
                                    </ValidationProvider>

                                </li>
                            </ul>
                            <ul class="asset-details asset-details--contacts">
                                <li class="contact-header">SECONDARY CONTACT</li>
                                <li>
                                    <span>Name</span>
                                    <span v-if="editAsset == false">
                                        <span v-if="asset.secondary_contact_name">
                                            {{ asset.secondary_contact_name }}
                                        </span>
                                        <span v-else><i>Unassigned</i></span>
                                    </span>
                                    <ValidationProvider rules="noComma" v-else name="Secondary Contact Name" v-slot="{ errors }">
                                        <span class="field">
                                            <InputText type="text" class="p-inputtext p-d-block" placeholder="Enter Name" :class="{ 'p-invalid': errors.length > 0 }" v-model="info.secondary_contact_name" />
                                            <small class="p-error p-d-block" v-if="errors[0]">
                                                {{ errors[0] }}
                                            </small>
                                        </span>
                                    </ValidationProvider>
                                </li>
                                <li>
                                    <span>Telephone Number (UK)</span>
                                    <span v-if="editAsset == false">
                                        <span v-if="asset.secondary_contact_phone">
                                            {{ asset.secondary_contact_phone }}
                                        </span>
                                        <span v-else><i>Unassigned</i></span>
                                    </span>
                                    <span class="field" v-else>
                                        <InputText type="number" class="p-inputtext p-d-block" placeholder="Enter Telephone Number" v-model="info.secondary_contact_phone" />
                                    </span>
                                </li>
                                <li>
                                    <span>Email Address</span>
                                    <span v-if="editAsset == false">
                                        <span v-if="asset.secondary_contact_email">
                                            {{ asset.secondary_contact_email }}
                                        </span>
                                        <span v-else><i>Unassigned</i></span>
                                    </span>
                                    <ValidationProvider rules="email" v-else name="Email Address" v-slot="{ errors }">
                                        <span class="field">
                                            <InputText class="p-inputtext p-d-block" placeholder="Enter Email Address" :class="{ 'p-invalid': errors.length > 0 }" v-model="info.secondary_contact_email" />
                                            <small id="" class="p-error p-d-block" v-if="errors[0]">
                                                {{ errors[0] }}
                                            </small>
                                        </span>
                                    </ValidationProvider>
                                </li>
                            </ul>
                        </div>
                    </TabPanel>
                    <TabPanel header="Attendance">
                        <ul class="asset-details">
                            <li>
                                <span>Attendance Schedule Start Date</span>
                                <span v-if="editAsset == false">
                                    <span v-if="asset.maintenance_schedule_start_date">
                                        {{ format_date(asset.maintenance_schedule_start_date.seconds * 1000) }}
                                    </span>
                                    <span v-else><i>Unassigned</i></span>
                                </span>
                                <span class="field" v-else>
                                    <Calendar :manualInput="false" v-model="info.maintenance_schedule_start_date" dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" :showButtonBar="true" />
                                </span>
                            </li>
                            <li>
                                <span>Last Attended Date</span>
                                <span v-if="asset.last_maintained_date">
                                    {{ format_date(asset.last_maintained_date.seconds * 1000) }}
                                </span>
                                <span v-else><i>Unassigned</i></span>
                            </li>
                            <li>
                                <span>Attendance Frequency</span>
                                <span v-if="editAsset == false">
                                    <span v-if="asset.maintenance_frequency">
                                        {{ asset.maintenance_frequency.label }}
                                    </span>
                                    <span v-else><i>Unassigned</i></span>
                                </span>
                                <span class="field" v-else>
                                    <Dropdown v-model="info.maintenance_frequency" :options="maintenance_frequencies" optionLabel="label" placeholder="Select a Frequency" />
                                </span>
                            </li>
                            <li>
                                <span>Attendance Status</span>
                                <span v-if="asset.maintenance_status">
                                    <i class="status_icon" :style="{ 'background-color': asset.maintenance_status.value }"></i>
                                    <span v-if="asset.maintenance_status.label">
                                        {{ asset.maintenance_status.label }}
                                    </span>
                                    <span v-else><i>Unassigned</i></span>
                                </span>
                            </li>
                        </ul>
                    </TabPanel>
                    <TabPanel header="Fault Status">
                        <ul class="asset-details" style="display: block;">
                            <li class="overall_status">
                                <span>Overall Fault Status</span>
                                <span>
                                    <span v-if="asset.fault_info && asset.fault_info.fault_status != ''">
                                        <i class="status_icon" :style="{ 'background-color': current_fault_status.hex }"></i>
                                        {{ setOverallFaultStatus(asset.fault_info.fault_status).label }}
                                    </span>
                                    <span v-else><i class="status_icon" :style="{ 'background-color': '#439446' }"></i><i>No Fault</i></span>
                                </span>

                                <DataTable :exportFilename="exportName()" :filters.sync="filterFaults" ref="dt" class="fault_table" :value="faults" dataKey="fault_id" sortField="fault_id" :sortOrder="-1" :loading="faultsLoading" :paginator="true" :rows="12">
                                    <template #empty>
                                        No Faults found.
                                    </template>

                                    <template #loading>
                                        Loading faults. Please wait.
                                    </template>

                                    <template #header>
                                        <div class="p-d-flex p-jc-between p-ai-center" style="gap: 1rem;">
                                            <h4 class="p-mb-0 p-mr-auto">Faults</h4>
                                            <InputText v-model="filterFaults['global'].value" placeholder="Search" />
                                            <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
                                        </div>
                                    </template>

                                    <Column field="fault_id" header="ID" :sortable="true">
                                        <template #body="slotProps">
                                            {{ slotProps.data.fault_id }}
                                        </template>
                                    </Column>

                                    <Column field="fault_reporter_name" header="Raised by Name" :sortable="true">
                                        <template #body="slotProps">
                                            {{ slotProps.data.fault_reporter_name }}
                                        </template>
                                    </Column>

                                    <Column field="fault_reporter_company" header="Raised by Company" :sortable="true">
                                        <template #body="slotProps">
                                            {{ slotProps.data.fault_reporter_company }}
                                        </template>
                                    </Column>

                                    <Column field="fault_report_note" header="Notes" :sortable="true">
                                        <template #body="slotProps">
                                            <p class="fault_note" :title="slotProps.data.fault_report_note">
                                                {{ truncatedNote(slotProps.data.fault_report_note) }}
                                            </p>
                                        </template>
                                    </Column>

                                    <Column field="fault_status_timestamp" header="Created At" :sortable="true">
                                        <template #body="slotProps">
                                            {{ slotProps.data.fault_status_timestamp }}
                                        </template>
                                    </Column>

                                    <Column field="last_updated_timestamp" header="Last Updated" :sortable="true">
                                        <template #body="slotProps">
                                            <span v-if="slotProps.data.last_updated_timestamp">{{ slotProps.data.last_updated_timestamp }}</span>
                                            <i v-else>Never Updated</i>
                                        </template>
                                    </Column>

                                    <Column field="fault_status" header="Status" :sortable="true">
                                        <template #body="slotProps">
                                            <div class="p-d-flex" style="align-items: baseline;">
                                                <i class="status_icon" :style="{ 'background-color': slotProps.data.meta.hex }"></i>
                                                <span v-if="user.data.role.permissionLevel >= 8">
                                                    <Dropdown @change="openEditFaultModal(slotProps.data.key, slotProps.data.meta.value, slotProps.data.fault_id)" v-model="slotProps.data.meta" :options="fault_statuses" optionLabel="label" placeholder="Select a Status" />
                                                </span>
                                                <span v-else>
                                                    {{ slotProps.data.meta.label }}
                                                </span>
                                            </div>
                                        </template>
                                    </Column>
                                    <template #footer>
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            <p class="p-mb-0">Number of Faults Reported: <strong>{{ faults ? faults.length : 0 }}</strong></p>
                                            <Button label="Report New Fault" icon="pi pi-pencil" @click.prevent="showNewFaultModal = true" />
                                        </div>
                                    </template>
                                </DataTable>
                            </li>
                        </ul>
                    </TabPanel>
                </TabView>
                <div class="asset-actions">
                    <div class="p-d-flex p-jc-between">
                        <span>
                            <Button v-if="editAsset == false" label="Edit Asset" icon="pi pi-pencil" @click="editAssetDetails()" />
                            <Button v-else label="Save Asset" icon="pi pi-save" @click.prevent="saveAsset()" class="p-button-primary p-button" />
                            <span style="width:160px; display:inline-block; margin-left: 1rem;">
                                <Button :label="copyLabel" class="p-button-link" @click="copyNFCLocation" />
                            </span>
                        </span>
                        <span>
                            <Button v-if="editAsset == true" label="Cancel" class="p-button-link" @click="cancelAsset()" />
                        </span>
                        <router-link class="p-button-success p-ml-auto p-button p-component" target='_blank' :to="'/check-in-out/' + client.key + '/' + asset.site_id + '/' + asset.key">
                            Asset / Job Actions
                        </router-link>
                        <Button style="" type="button" label="Generate Absolute QR Code" class="p-button-primary p-ml-2" @click="generateQRCode(false)" />
                        <Button style="" type="button" label="Generate Relative QR Code" class="p-button-primary p-ml-2" @click="generateQRCode(true)" />
                    </div>
                </div>
            </form>
            <Dialog :modal="true" :header="'Edit status for Fault ' + faultModalData.fault_id" :visible.sync="showEditFaultModal">
                <Textarea v-model="newFaultNote" class="p-mt-1" :autoResize="true" rows="5" cols="50" />
                <br>
                <Button style="" type="button" label="Submit" class="p-button-primary p-mt-2 p-d-block p-ml-auto" @click="updateFaultStatus(faultModalData.key, faultModalData.value, faultModalData.fault_id)" />
            </Dialog>
            <Dialog :modal="true" :header="'Report New Fault'" :visible.sync="showNewFaultModal">
                <Textarea v-model="newFaultNote" class="p-mt-1" :autoResize="true" rows="5" cols="50" />
                <br>
                <Button style="" type="button" label="Submit" class="p-button-primary p-mt-2 p-d-block p-ml-auto" @click="reportNewFault()" />
            </Dialog>
        </ValidationObserver>
    </div>
</template>

<script>

import { db } from '@/firebase';
import Vue2Filters from 'vue2-filters';
import moment from 'moment';
import jspdf from 'jspdf';
import QRious from 'qrious';
import { mapGetters } from "vuex";
import { ValidationProvider } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import axios from 'axios';
import { FilterMatchMode } from 'primevue/api';
import { calculateMaintenanceStatus, calculateWarrantyStatus, calculateLifecycleStatus } from '@/utils/maintenanceUtils';

extend('required', {
    ...required,
    message: (fieldName) => {
        return `Please enter ${fieldName.toLowerCase()}`;
    }
});

extend('email', {
    ...email,
    message: () => {
        return `Please enter a correctly formatted email address.`;
    }
});

extend('noComma', {
    validate: (value) => {
        return !value || !value.includes(',');
    },
    message: 'Commas are not allowed in this field'
});

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    mixins: [Vue2Filters.mixin],
    data() {
        return {
            calendar: null,
            info: {
                name: '',
                description: '',
                location_reference: '',
                area: '',
                location: '',
                additional_info: '',
                maintenance_frequency: '',
                primary_contact_name: '',
                primary_contact_phone: '',
                primary_contact_email: '',
                secondary_contact_name: '',
                secondary_contact_phone: '',
                secondary_contact_email: '',
                maintenance_schedule_start_date: '',
            },
            editAsset: false,
            copyLabel: 'Copy NFC Location',
            client: {},
            asset: {},
            last_maintained_date: '',
            first_maintained_date: '',
            maintenance_frequencies: [
                { label: 'Daily', value: 86400, threshold: 10800 }, // 10800 = 3 hours for a 2 hour threshold
                { label: 'Weekly', value: 604800, threshold: 172800 },
                { label: 'Monthly', value: 2630000, threshold: 604800 },
                { label: 'Quarterly', value: 7890000, threshold: 1209600 },
                { label: '6 Monthly', value: 15780000, threshold: 2630000 },
                { label: 'Annually', value: 31560000, threshold: 2630000 },
                { label: '5 Yearly', value: 157800000, threshold: 31560000 }
            ],
            fault_statuses: [
                { label: 'Fault', value: 'active', hex: '#f31b2b' },
                { label: 'In Progress', value: 'in_progress', hex: '#ffbf00' },
                { label: 'Rectified', value: 'rectified', hex: '#1f5ea4' }
            ],
            current_fault_status: '',
            faults: [],
            faultsLoading: true,
            faultModalData: {},
            showEditFaultModal: false,
            showNewFaultModal: false,
            newFaultNote: '',
            filterFaults: { global: { value: null, matchMode: FilterMatchMode.CONTAINS } },
        }
    },
    mounted() {
        this.fetchAsset();
        this.getAllFaults();
    },
    computed: {
        ...mapGetters({
            user: "user"
        }),
    },
    firestore() {
        return {
            client: db.collection('clients').doc(this.$route.params.client_id)
        }
    },
    methods: {
        async fetchAsset() {
            // Fetch the asset document from Firestore
            await this.updateStatus();
            const assetDoc = await db.collection('assets').doc(this.$route.params.id).get();
            if (assetDoc.exists) {
                const asset = assetDoc.data()
                this.asset = {
                    ...asset,
                    excludeNotifications: asset.excludeNotifications ? asset.excludeNotifications : false,
                    key: this.$route.params.id
                }; // Store a local copy of the data

                console.log(this.asset.fault_info)
            } else {
                console.log("Asset document not found.");
            }
        },
        format_date(value) {
            if (!isNaN(value)) {
                return moment(value).format('DD/MM/YYYY')
            } else {
                return;
            }
        },
        // added 11/01/2023
        copyNFCLocation() {
            // success message
            this.copyLabel = 'Copied!';
            // value to copy
            let nfcLocation = window.location.origin + '/check-in-out/' + this.client.key + '/' + this.asset.site_id + '/' + this.asset.key;
            // copy command
            navigator.clipboard.writeText(nfcLocation);
            // reset label value
            setTimeout(function () {
                this.copyLabel = 'Copy NFC Location';
            }.bind(this), 1000);

        },
        generateQRCode(isRelative) {

            let doc = new jspdf('portrait', 'mm', 'a4');
            let logo = new Image();
            logo.src = '/logo-qr.png';
            let qr = new Image();

            qr.src = '/logo-qr.png';

            let QRValue = (isRelative) ? '/check-in-out/' + this.$route.params.client_id + '/' + this.asset.site_id + '/' + this.asset.key
                : window.location.origin + '/check-in-out/' + this.$route.params.client_id + '/' + this.asset.site_id + '/' + this.asset.key;

            let qr2 = new QRious({
                value: QRValue,
                size: 600,
                level: 'H'
            });

            qr2 = qr2.toDataURL();
            let pX = 20;
            let pY = 20;

            doc.setFont('courier', 'bold');
            doc.setFontSize(50);
            // doc.addImage(logo, 'PNG', pX + 20, pY + 2, 16, 4);
            doc.addImage(qr2, 'PNG', pX + 1, pY + 1, 50, 50);

            doc.save('assets-' + this.asset.key + '.pdf');
        },
        editAssetDetails() {
            this.editAsset = !this.editAsset;

            if (this.editAsset == true) {
                this.info.name = this.asset.name;
                this.info.description = this.asset.description;
                this.info.additional_info = this.asset.additional_info;
                this.info.location_reference = this.asset.location_reference;
                this.info.area = this.asset.area;
                this.info.location = this.asset.location;
                this.info.maintenance_frequency = this.asset.maintenance_frequency;
                this.info.maintenance_schedule_start_date = (this.asset.maintenance_schedule_start_date) ? new Date(this.asset.maintenance_schedule_start_date.seconds * 1000) : '';
                this.info.primary_contact_name = this.asset.primary_contact_name;
                this.info.primary_contact_phone = this.asset.primary_contact_phone;
                this.info.primary_contact_email = this.asset.primary_contact_email;
                this.info.secondary_contact_name = this.asset.secondary_contact_name;
                this.info.secondary_contact_phone = this.asset.secondary_contact_phone;
                this.info.secondary_contact_email = this.asset.secondary_contact_email;
                this.info.excludeNotifications = this.asset.excludeNotifications;
            }
        },
        cancelAsset() {
            this.editAsset = !this.editAsset;
        },
        async saveAsset() {
            const assetDoc = await db.collection('assets').doc(this.$route.params.id);
            this.$refs.info.validate().then(success => {
                if (success) {
                    assetDoc.update({
                        name: (this.info.name) ? this.info.name : '',
                        description: this.info.description,
                        location_reference: (this.info.location_reference) ? this.info.location_reference : '',
                        area: (this.info.area) ? this.info.area : '',
                        location: (this.info.location) ? this.info.location : '',
                        additional_info: (this.info.additional_info) ? this.info.additional_info : '',
                        maintenance_frequency: this.info.maintenance_frequency,
                        maintenance_schedule_start_date: this.info.maintenance_schedule_start_date,
                        primary_contact_name: (this.info.primary_contact_name) ? this.info.primary_contact_name : '', // think these values need the ternary because they aren't in the document on creation, might need to look into this later
                        primary_contact_phone: (this.info.primary_contact_phone) ? this.info.primary_contact_phone : '',
                        primary_contact_email: (this.info.primary_contact_email) ? this.info.primary_contact_email : '',
                        secondary_contact_name: (this.info.secondary_contact_name) ? this.info.secondary_contact_name : '',
                        secondary_contact_phone: (this.info.secondary_contact_phone) ? this.info.secondary_contact_phone : '',
                        secondary_contact_email: (this.info.secondary_contact_email) ? this.info.secondary_contact_email : '',
                        excludeNotifications: this.asset.excludeNotifications
                    }).then(() => {
                        this.editAsset = false;
                        this.updateStatus();

                        const filterSetUrl = process.env.VUE_APP_API_URL + '/filter/set';

                        axios({
                            method: 'post',
                            url: filterSetUrl,
                            headers: {
                                'Authorization': `Bearer ${this.user.auth.accessToken}`
                            },
                            data: {
                                'siteId': this.$route.params.site_id,
                            }
                        }).then(() => {
                            this.fetchAsset();
                        }).catch(error => { console.error(error) });

                        db.collection('logs').add({
                            activity: 'Asset details updated',
                            timestamp: new Date(),
                            user: this.user.data.email,
                            client_id: this.user.data.client.key
                        }).then(() => {
                            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Asset details updated', life: 3000 });
                        });
                    });
                }
            });

        },
        async updateStatus() {
            try {
                const assetDocRef = db.collection('assets').doc(this.$route.params.id);
                const response = await assetDocRef.get();

                if (!response.exists) {
                    console.log("Asset document not found.");
                    return;
                }

                const asset = response.data();
                const currentTime = moment().unix();

                // Calculate all statuses using utility functions
                const maintenanceStatus = calculateMaintenanceStatus(asset, currentTime);
                const warrantyStatus = calculateWarrantyStatus(asset, currentTime);
                const lifecycleStatus = calculateLifecycleStatus(asset, currentTime);

                // Update all statuses in a single batch operation
                await assetDocRef.update({
                    maintenance_status: maintenanceStatus,
                    warranty_status: warrantyStatus,
                    lifecycle_status: lifecycleStatus
                });

            } catch (error) {
                console.error('Error in updateStatus:', error);
            }
        },
        setOverallFaultStatus(faultValue) {
            this.current_fault_status = this.fault_statuses.find(x => x.value == faultValue)
            // console.log(this.current_fault_status)
            return this.fault_statuses.find(x => x.value == faultValue)
        },
        updateFaultStatus(faultKey = null, faultStatus) {
            // console.log(this.faults[this.faults.findIndex(x => x.key == faultKey)].fault_status)

            // this.faults[this.faults.findIndex(x => x.key == faultKey)].fault_status = faultStatus

            const reportFaultEndpoint = process.env.VUE_APP_API_URL + '/fault-report'

            axios({
                method: 'post',
                url: reportFaultEndpoint,
                data: {
                    // all these are required to hit this function, so shouldn't be a problem
                    'asset_id': this.$route.params.id,
                    'site_id': this.$route.params.site_id,
                    'client_id': this.$route.params.client_id,
                    'fault_status': faultStatus,
                    'notes': this.newFaultNote, // no notes allowed currently
                    'reporter_name': this.user.data.email, // admin user email
                    'reporter_company': this.user.data.client.name, // admin user client name,
                    'fault_id': faultKey // this is the document ID, NOT the fault_id metadata
                }
            }).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Fault Status Updated', life: 3000 });
                this.getAllFaults()
                this.showEditFaultModal = false
                this.faultModalData = {}
                this.newFaultNote = ''
                setTimeout(() => { // not a fan of this - needs looking into later
                    this.fetchAsset()
                }, 500);
            }).catch(error => { console.error(error) });
        },
        getAllFaults() {
            this.faultsLoading = true
            const getFaultsEndpoint = process.env.VUE_APP_API_URL + '/get-asset-faults'

            axios({
                method: 'post',
                url: getFaultsEndpoint,
                data: {
                    // all these are required to hit this function, so shouldn't be a problem
                    'asset_id': this.$route.params.id
                }
            }).then((response) => {
                this.faults = response.data
                this.faults.forEach(fault => {
                    fault.meta = this.setIndividualFaultStatus(fault.fault_status),
                        fault.unix = moment(fault.fault_status_timestamp, "DD/MM/YYYY @ hh:mma").unix() // unix required for sorting
                });
                this.faultsLoading = false
            }).catch(error => { console.error(error) });
        },
        setIndividualFaultStatus(faultValue) {
            // console.log(this.current_fault_status)
            return this.fault_statuses.find(x => x.value == faultValue)
        },
        openEditFaultModal(key, value, fault_id) {
            this.faultModalData.key = key
            this.faultModalData.value = value
            this.faultModalData.fault_id = fault_id

            this.showEditFaultModal = true
        },
        reportNewFault() {
            const reportFaultEndpoint = process.env.VUE_APP_API_URL + '/fault-report'

            axios({
                method: 'post',
                url: reportFaultEndpoint,
                data: {
                    // all these are required to hit this function, so shouldn't be a problem
                    'asset_id': this.$route.params.id,
                    'site_id': this.$route.params.site_id,
                    'client_id': this.$route.params.client_id,
                    'fault_status': 'active',
                    'notes': this.newFaultNote, // no notes allowed currently
                    'reporter_name': this.user.data.email, // admin user email
                    'reporter_company': this.user.data.client.name, // admin user client name,
                }
            }).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'New Fault Reported', life: 3000 });
                this.getAllFaults()
                this.showNewFaultModal = false
                this.newFaultNote = ''
                setTimeout(() => { // not a fan of this - needs looking into later
                    this.fetchAsset()
                }, 500);
            }).catch(error => { console.error(error) });
        },
        exportName() {

            let assetName = this.asset.name;
            let currentDate = moment(new Date()).format('YYYY-MM-DD');

            return assetName + '-current-faults-' + currentDate;
        },
        exportCSV() {
            // this.$refs.dt.exportCSV();
            let faults = this.faults
            console.log(faults)
            faults.sort((a, b) => b.fault_id - a.fault_id); // sort by timestamp

            // Get table data
            const dataToExport = faults.map((fault) => {
                return {
                    'ID': this.sanitizeForCSV(fault.fault_id),
                    'Raised by Name': this.sanitizeForCSV(fault.fault_reporter_name),
                    'Raised by Company': this.sanitizeForCSV(fault.fault_reporter_company),
                    'Notes': this.sanitizeForCSV(fault.fault_report_note),
                    'Created At': this.sanitizeForCSV(fault.fault_status_timestamp),
                    'Last Updated': this.sanitizeForCSV(fault.last_updated_timestamp),
                    'Status': this.sanitizeForCSV(fault.meta.label)
                };
            });

            // Convert the data into CSV format
            const csvData = this.generateCSV(dataToExport);
            let currentDate = moment(new Date()).format('YYYY-MM-DD');

            let fileName = this.asset.name + '-current-faults-' + currentDate;

            // Trigger the download
            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName + '.csv');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        // Helper method to sanitize each field for CSV export
        sanitizeForCSV(value) {
            if (value === null || value === undefined) {
                return ''; // Handle null/undefined values as empty strings
            }
            // Convert the value to a string
            let str = String(value);

            // If the field contains commas, quotes, or newlines, wrap it in double quotes
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                // Escape double quotes by replacing " with ""
                str = str.replace(/"/g, '""');
                // Wrap the field in double quotes
                return `"${str}"`;
            }
            return str;
        },
        // Helper function to convert JSON data to CSV format
        generateCSV(data) {
            const header = Object.keys(data[0]).join(',') + '\n';
            const rows = data.map((row) => Object.values(row).join(',')).join('\n');
            return header + rows;
        },
        truncatedNote(note) {
            return note.length > 200
                ? note.substring(0, 200) + "..."
                : note;
        }
    },
}
</script>

<style scoped lang="scss">
.status_icon {
    margin-right: 0.5rem;
}

.status_icon+span {
    white-space: nowrap;
}

.asset-details {
    padding-block: 1rem;
    padding-inline: 0;
    list-style: none;
    margin: 0;

    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    li {

        >span {
            &:first-of-type {
                display: block;
                font-size: 1rem;
                color: #74757B;
                margin-bottom: 0.25rem;
            }

            &:last-of-type {
                font-weight: bold;
                display: block;
                padding-bottom: 1rem;
                font-size: 16px;
                min-height: 2.5rem;
                border-bottom: 1px solid #dee2e6;

                i {
                    font-weight: 400;
                    color: #c5c5c5;
                }
            }
        }

        &.warranty_toggle {
            display: flex;
            gap: 0.5rem;
            align-items: center;
            padding-bottom: 1rem;
            border-bottom: 1px solid #dee2e6;

            >span,
            .warranty_switch {
                min-height: 1.75rem;
                display: contents;
                border: 0;
                margin: 0;
                padding: 0;
            }
        }

        .field {
            width: 100%;

            input {
                width: 100%;
            }

        }
    }
}

.small__note {
    font-weight: 400;
    font-style: italic;
    font-size: 12px;
}

.overall_status {
    span {
        font-size: 14px !important;
    }

    .status_icon {
        width: 1.5rem;
        height: 1.5rem;
    }
}

.fault_table {
    margin-top: 1rem;
}

.fault_header {
    background: #f8f9fa;
    margin: 0;
    padding: 9px 10px;
    margin-top: 2rem;
}
</style>